export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-10 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/103781c2-bc14-4b28-988b-6ca01a70a8b4.png" 
                alt="KVADRUM Logo" 
                className="h-12 w-12 object-contain"
              />
              <span className="text-5xl font-bold">KVADRUM</span>
            </div>
            <p className="text-base text-gray-400 mb-10">Your trusted VPN solution</p>
            
            <div className="flex items-center space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:border-teal-500 hover:bg-teal-500/10 transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:border-teal-500 hover:bg-teal-500/10 transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:border-teal-500 hover:bg-teal-500/10 transition-all cursor-pointer">
                <i className="ri-github-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-6">Contact</h4>
            <div className="space-y-4 text-base">
              <p className="text-white leading-relaxed">
                Zaheji 19<br />
                51415 Lovran<br />
                Croatia
              </p>
              <p className="text-white">+1 8555527578</p>
              <p className="text-white">information@kvadrumdoo.com</p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-6">Company</h4>
            <div className="space-y-4">
              <button onClick={() => scrollToSection('about')} className="block text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                About Us
              </button>
              <button onClick={() => scrollToSection('features')} className="block text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                Features
              </button>
              <button onClick={() => scrollToSection('pricing')} className="block text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                Pricing
              </button>
              <button onClick={() => scrollToSection('support')} className="block text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                Support
              </button>
              <a href="#" className="block text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="block text-base text-gray-400 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © 2025 KVADRUM d.o.o. All rights reserved
            </p>
            <div className="flex items-center space-x-8">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
